// extracted by mini-css-extract-plugin
export default {"header":"Table_header__6iUdG","link":"Table_link__u9+Zx","active":"Table_active__W+oBo","inactive":"Table_inactive__Ly2e0"};